import {Component, Input} from '@angular/core';

@Component({
  selector: 'nc-label',
  templateUrl: 'nc-label.component.html',
  styleUrls: ['nc-label.component.scss']
})
export class NcLabelComponent {
  @Input() value: string;
  @Input() tooltip: string;
  @Input() isOutlineIcon: boolean;
  @Input() id: string;

}
